import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import './i18n/index.js';
import './index.css';
import { startServiceWorker } from './core/pwa/swUpdate.js';

// Service worker (offline) + nieuwe versie na een deploy meteen gebruiken
startServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
